import { PaddingProps, styledPadding } from '@tink/core/src/components/atoms/Box/Box';
import { styled } from '../../../core/theme/styled';

type WrapperProps = {
  id?: string;
  relative?: boolean;
};

type MainProps = PaddingProps & {
  centerVertically?: boolean;
  centerHorizontally?: boolean;
  fullWidth?: boolean;
};

type Props = WrapperProps & MainProps;

const ContentBodyWrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  ${({ relative }) => relative && 'position: relative;'}
`;

export const StyledMain = styled.main<MainProps>`
  width: 100%;
  ${({ fullWidth }) =>
    !fullWidth &&
    `
    max-width: 400px;
    `}

  max-height: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: ${(props) => (props.centerVertically ? 'center' : 'unset')};
  align-items: ${(props) => (props.centerHorizontally ? 'center' : 'unset')};
  padding: 0 ${(props) => props.theme.sizes.normal};
  ${styledPadding};
`;

export const ContentBody: React.FC<Props> = ({ children, id, relative, ...mainProps }) => {
  return (
    <ContentBodyWrapper id={id} relative={relative} aria-live="assertive">
      <StyledMain {...mainProps}>{children}</StyledMain>
    </ContentBodyWrapper>
  );
};

export const PrimaryContentColumn: React.FC<MainProps> = ({ children, ...props }) => {
  return (
    <StyledMain {...props} as="div">
      {children}
    </StyledMain>
  );
};
